module.exports = __webpack_public_path__ + "img/product13.3e1d0ab2.jpg";